import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import localStore from 'store';
import { isEmpty } from 'lodash';
import {
  Message,
  Image,
  Button,
  Label,
  Loader,
  Dimmer,
} from 'semantic-ui-react';
import withPagination from './WithPagination';
import LoadingDataEnhancer from './LoadingData';
import doc from '../assets/doc.png';

import ReactDropzone from '../components/ReactDropzone';

import SurchargePriceUploaderList from '../views/SurchargePriceUploader/List';
import surchargePriceUploadsQuery from '../graphql/surchargePriceUploadsQuery';
import { setPage } from '../data/page/actions';

class SurchargePriceUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFile: null,
      flashMessage: null,
      loading: false,
    };
  }

  onDrop = files => {
    this.setState({ selectedFile: { name: files[0].name, file: files[0] } });
  };

  saveFile = () => {
    const { selectedFile } = this.state;
    this.setState({ loading: true, flashMessage: '' });
    if (!isEmpty(selectedFile)) {
      this.uploadImage(selectedFile.file);
    } else {
      this.setState({ loading: false });
    }
  };

  uploadImage = file => {
    const { data, setPage: setPageProp } = this.props;
    const formData = new FormData();
    const token = localStore.get('jwt');

    formData.append('file', file);
    formData.append('model', 'SurchargePriceUploader');
    formData.append('AUTHORIZATION', token ? `${token}` : null);

    axios
      .post(process.env.REACT_APP_UPLOAD_API_URL, formData)
      .then(() => {
        this.setState({
          flashMessage: 'Successfully Uploaded file and queued for processing',
          selectedFile: null,
          loading: false,
        });
        data.refetch();
        setPageProp({});
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const {
      data: { surchargePriceUploads },
    } = this.props;
    const allFiles = surchargePriceUploads;
    const { flashMessage, selectedFile, loading } = this.state;

    const thumb = {
      display: 'inline-flex',
      borderRadius: 2,
      border: '1px solid #eaeaea',
      marginBottom: 2,
      marginRight: 2,
      width: 100,
      height: 100,
      padding: 4,
      boxSizing: 'border-box',
    };

    const thumbInner = {
      display: 'flex',
      minWidth: 0,
      overflow: 'hidden',
    };

    const img = {
      display: 'block',
      width: 'auto',
      height: '100%',
    };

    return (
      <div className='drop-zone'>
        {flashMessage && (
          <Message
            onDismiss={this.handleDismiss}
            content={flashMessage}
            positive
          />
        )}
        <ReactDropzone
          accept='.csv'
          onDrop={this.onDrop}
          multiple={false}
          className='react-drop-zone react-drop-zone-small'
        >
          Drop Surcharge Price Document (CSV File) here!!
        </ReactDropzone>

        <Button color='green' onClick={this.saveFile} inverted>
          {' '}
          Save
        </Button>
        <br />
        {selectedFile && (
          <Label>
            <div style={thumb}>
              <div style={thumbInner}>
                <Image src={doc} style={img} />
              </div>
            </div>
            <br />
            {selectedFile.name}
          </Label>
        )}
        {loading && (
          <Dimmer active inverted>
            <Loader size='large'>Loading</Loader>
          </Dimmer>
        )}
        <br />
        <br />
        <SurchargePriceUploaderList allFiles={allFiles} />
      </div>
    );
  }
}

SurchargePriceUploader.propTypes = {
  data: PropTypes.shape({
    refetch: PropTypes.func.isRequired,
    surchargePriceUploads: PropTypes.array,
  }).isRequired,
  setPage: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  setPage: () => {
    dispatch(setPage());
  },
});

export default compose(
  withRouter,
  withPagination(surchargePriceUploadsQuery, 'surchargePriceUploads'),
  LoadingDataEnhancer,
  connect(
    null,
    mapDispatchToProps
  )
)(SurchargePriceUploader);
